import axios from 'axios';
import { useDispatch } from 'react-redux';
import { themeRegister } from 'src/actions/themeActions';

const URL_STATIC_THEME = 'https://estatico.cabal.coop.py/public/dimo/theme1/images/';
const BASE_URL = 'https://estatico.cabal.coop.py/public/dimo';

/**
 * Función asíncrona para obtener y procesar datos desde una URL.
 */
async function fetchData(url) {
  let data;
  let error;
  let loading = true;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const dataText = await response.text();
    const fixText = dataText.replace(/'/g, '"').replace(/(\w+)\s*:/g, '"$1":').replace(/"https"/g, 'https').replace(/,\s*}/g, '}');
    const jsonData = JSON.parse(fixText);
    data = jsonData;
  } catch (err) {
    error = err.message;
  } finally {
    loading = false;
  }

  return { data, loading, error };
}


async function loadThemeConfig(dispatch, themeConfigRemote) {
  await dispatch(themeRegister(themeConfigRemote));
  localStorage.setItem('themeConfig', JSON.stringify(themeConfigRemote));
}


/**
 * Función asíncrona para obtener la configuración de una URL específica.
 */
async function fetchConfig(url) {
  try {
    const urlActual = window.location.href;
    let url= urlActual.split('/')[2];
    
    if (url.includes('localhost')) {
      url = 'capiatatest.cabal.coop.py'; // Para desarrollo local, cambiar por el codparticipante que quieras probar
    }

    const config = await fetchData(`${BASE_URL}/${url}/config.js`);

    if (config.error) {
      console.error(`Error al obtener config de ${url}:`, config.error);
      return { error: config.error };
    }

    let paleta = { data: {} };
    if (config.data?.paleta) {
      try {
        paleta = await fetchData(config.data.paleta);
        if (paleta.error) {
          console.warn(`Error al obtener paleta de ${url}:`, paleta.error);
        }
      } catch (error) {
        console.warn(`Error al obtener paleta de ${url}:`, error);
      }
    }

    if (config.data?.requireAuth !== undefined) {
      localStorage.setItem("requireAuth", JSON.stringify(config.data.requireAuth));
    }

    return { ...config.data, ...paleta.data };
    
//          const config = {
//   "code": "1621",
//   "tarjetaEmisor":["83"],
//   "paleta":"https://estaticopre.cabal.coop.py/public/dimo/theme/1621/palette/palette.js",
//   "loginView": {
//     "logoUrl": "https://estaticopre.cabal.coop.py/public/dimo/1621/images/logoUrl.png",
//     "backgroundWebImage":"https://estaticopre.cabal.coop.py/public/dimo/theme/1621/images/backgroundWebImage.png",
//     "backgroundMobileImage":"https://estaticopre.cabal.coop.py/public/dimo/theme/1621/images/backgroundMobileImage.png",
//     "responsiveView": false,
//   },
//   "logoWidthMax": "150px",
//   "logoWidthMin": "150px",
//   "coopIcon":"https://estaticopre.cabal.coop.py/public/dimo/1621/images/coopIcon.png",
//   "headerIcon":"https://estaticopre.cabal.coop.py/public/dimo/1621/images/headerIcon.png",
//   "splashIcon":"https://estaticopre.cabal.coop.py/public/dimo/1621/images/splashIcon.png",
// "buttonIcon":"https://estaticopre.cabal.coop.py/public/dimo/1621/images/buttonIcon.png",
// "institucional":"https://www.ayacape.coop.py/v3/",
// "nombre":"Ayacape",
// "requireAuth": false,
// "backgroundWebInicio": null,
// "backgroundMobileInicio": null,
// "requiereDarkLogin": true,
// "requiereFullTheme": true,
// "coopView": true,
// "requiereFactura": false,
// "requiereCajaAhorroAuto": false,
// "requierePrestamoTipoCredito": false,
// "requierePrestamoColegioSeparado": false,
// "requierePagoTarjetaExterno": false,
// "servicioPagoTarjetaExterno": "Ayacape",
// "requiereExcedentes": true,
// "popup": [],
// "cvvRequire":true,
// "solitudPlasticoRequire":true,
// "activacionPlasticoRequire":true,
// "solicitudReimpresionRequire":true,
// "recuperarPinRequire":true,
// "useLegacyBiometricLogic": false,
// "useLargeBottomBar": false,
// "isIphoneAppUpdated": false,
// "isAndroidAppUpdated": true,
// "requireToken":{
//   "android": true,
//   "ios": true}
// }
// const paleta = {
//   "backgroundColor": "#F2F2F2",
//   "primary": "#157136",
//   "secondary": "#154F36",
//   "tertiary": "#F2F2F2",
//   "textPrimary": "#154F36",
//   "textSecondary": "#157136",
//   "textTertiary": "#707070",
//   "cardBackground": "#dcdcdc",
//   "spinner": "#157136",
//   "navbarLeft": {
//     "backgroundColor": "#154F36",
//     "text": "#F2F2F2",
//     "icon": "#F2F2F2"
//   },
//   "navbarButtom": {
//     "backgroundColor": "#157136",
//     "text": "#F2F2F2",
//     "icon": "#F2F2F2"
//   },
//   "codPromotor": {
//     "title": "#F2F2F2",
//     "code": "#F2F2F2"
//   },
//   "buttonSection": {
//     "backgroundColor": "#157136",
//     "text": "#F2F2F2",
//     "icon": "#157136"
//   },
//   "buttonStep": {
//     "backgroundColor": "#154F36",
//     "text": "#F2F2F2",
//     "icon": "#F2F2F2"
//   },
//   "buttonExtra": {
//     "backgroundColor": "#154F36",
//     "text": "#F2F2F2",
//     "icon": "#F2F2F2"
//   },
//   "buttonTreeDots": {
//     "color": "#154F36"
//   }
//   // ,
//   // "logoConfig": {
//   //   "icon_logo_sicoop": {
//   //     "logo_sicoop_app": "#FFFFFF",
//   //     "logo_sicoop_web": "#ffffff",
//   //     "logoVariant": "fullColor"
//   //   }
//   // }
// }

// return {
//     ...config,
//     ...paleta
//   };

  } catch (error) {
    console.error(`Error en fetchConfig para ${url}:`, error);
    return { error };
  }
}


/**
 * Busca la configuracion basada en la URL y la almacena en localStorage.
 */
export async function handleGetStorage() {
  const urlActual = window.location.href;
  const url = urlActual.split('/')[2];

  const config = await fetchConfig(url);
  if (config.error) {
    return config;
  }

  localStorage.setItem('themeConfig', JSON.stringify(config));

  return config;
}